module.exports = __webpack_public_path__ + "img/Chianxin-icon.16b6c35f.png";